import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import { useDispatch } from "react-redux";
import { addSphere, removeSphere, setSphereItems } from "./OotrSphereReducer";
import { OotItemDto } from "../hints/OotItemAutocomplete";
import { Box } from "@mui/material";
import SphereLine from "./SphereLine";
import { isNil } from "lodash";

interface SphereTrackerDisplayProps {
    isOutOfLogic?: true
}

const SphereTrackerDisplay = (props: SphereTrackerDisplayProps) => {

    let spheres = useSelector((state: AppState) => state.ui.ootr.sphere.spheres)
    let dispatch = useDispatch();

    // Add a new empty sphere or remove an empty sphere
    const onManageSphere = (sphereLevel: number, deleteSphere: boolean) => {

        if (spheres.length - 1 === sphereLevel && !deleteSphere)
            dispatch(addSphere())

        if (deleteSphere) {
            dispatch(removeSphere(sphereLevel))
        }
    }

    const setItems = (items: Array<OotItemDto | null>, sphereLevel: number) => {
        dispatch(setSphereItems({ id: sphereLevel, items: items }))
    }
    
    const manageChangePredecessorItem = (item: OotItemDto | null, sphereLevel: number, isChildReplacement?: true) => {

        if(isNil(item))
            return;

        for(let i = 0; i < spheres.length; i++)
        {
            let sphereItems = spheres[i].items;
            let nextSphereItems: Array<OotItemDto | null> = []
            if(i !== spheres.length - 1)
                nextSphereItems= spheres[i+1].items;

            console.log("Item to replace " + item.name + " : child : " + item.childName, sphereItems.some(x => x?.name === item.childName) && !nextSphereItems.some(x => x?.name === item.name))

            //si on trouve le predecessor alors on replace l'item a la bonne sphere
            if((sphereItems.some(x => x?.name === item.childName) && !nextSphereItems.some(x => x?.name === item.name)) || (isChildReplacement && sphereItems.some(x => x?.name === item.name)))
            {

               setItemAtPlaceAndChild(sphereLevel, i+1, item);

                break;
            }
        }
    }


    const setItemAtPlaceAndChild = (sphereOrigin: number, sphereDestination: number, item: OotItemDto | null) => {

        if(isNil(item))
            return;

        let nextSphereItems: Array<OotItemDto | null> = []
        if(sphereDestination <= spheres.length - 1)
            nextSphereItems= spheres[sphereDestination].items;

        console.log("Predecessor found sphere " + (sphereOrigin) + " placing item at sphere " + sphereDestination, item, [...nextSphereItems.filter(x =>!isNil(x)), item, null])
        dispatch(setSphereItems({ id: sphereDestination, items: [...nextSphereItems.filter(x =>!isNil(x)), item, null] }))
        console.log("end placing " + item.name + " at sphere " + sphereDestination)

        if(sphereDestination === spheres.length - 1){
            console.log("adding a sphere at the end of the array")
            onManageSphere(spheres.length - 1, false);
            
        }

        console.log("Removing item " + item.name + " from sphere " + (sphereOrigin), item, [...nextSphereItems.filter(x =>!isNil(x)), item, null])
        dispatch(setSphereItems({ id: sphereOrigin , items: [...spheres[sphereOrigin].items.filter(x => (x?.name !== item.name) && !isNil(x)), null] }))
        console.log("end removing " + item.name + " at sphere " + sphereOrigin)
        if(spheres[sphereOrigin].items.filter(x => x?.name !== item.name && !isNil(x)).length === 0){
            onManageSphere(sphereOrigin, true)
            console.log("removing empty sphere ")
        }

        //We update all the items that are successors (and their successors) of this item at the correct sphere level
        //a partir de la sphere d'origine on replace tous les enfants à la bonne sphere avec une recursive sur cette fonction
        let directChild: Array<OotItemDto | null> = []

        console.log("The Child Sphere is ", sphereOrigin + 1)

        for(let childSphere = sphereOrigin + 1; childSphere < spheres.length - 1; childSphere++)
        {
            directChild = spheres[childSphere].items.filter(x => x?.childName === item.name && !isNil(x));
            console.log("List of the child to replace Childs ", directChild)
            
            directChild.forEach(child => {
                console.log("replacing corretly the child " + item.name)
                setItemAtPlaceAndChild(childSphere, sphereDestination+1, child)
            
            })
        }
    }



    return <Box display="flex" flexDirection={"column"} alignContent={"center"} maxHeight={"600px"} flexShrink={0} flexWrap={"wrap"} margin="10px">
    {spheres.map(sphere => {
        return <Box display="flex" flexShrink={0} >
            {isNil(props.isOutOfLogic) && <Box display={"flex"} justifyContent={"center"} alignItems={"center"} width={"70px"}>
                Sphere {sphere.id}
            </Box>}
            <SphereLine isOutOfLogic={props.isOutOfLogic} sphereLevel={sphere.id} onSphereItemChange={onManageSphere} items={sphere.items} setSphereItems={setItems} manageChangePredecessorItem={manageChangePredecessorItem}/></Box>
        })}
</Box>
}

export default SphereTrackerDisplay